export const DocumentKeys = {
  AFFIDAVIT: 'affidavitstatingnotprivatefoundation',
  ARMED_FORCES_ID: 'armedforcesidcard',
  ARTICLE_ASSOC: 'articleassoc',
  ARTICLE_INCORP: 'articleincorp',
  AUDITORS_LETTER: 'auditorsletter',
  BANK_ID_CARD: 'bankidcard',
  CEDULA: 'cedula',
  CERT_INCORP: 'certincorp',
  CERT_LTD_PARTNER: 'certltdpartner',
  CERT_LOSS_NATIONALITY: 'certlossnationality',
  CERT_PARTNERSHIP: 'certpartnership',
  CERT_REG: 'certreg',
  CERT_OF_RESIDENCE: 'certofresidence',
  CONTROLLING_PERSON_SELF_CERTIFICATION: 'controllingpersonselfcertification',
  DATE_OF_BIRTH_SUPPORTING_DOC: 'dateofbirthsupportingdoc',
  DRIVING_LICENCE: 'drivinglicence',
  FORM_8233: 'form8233',
  FORM_8832: 'form8832',
  IRS_DETERMINATION_LETTER: 'irsdeterminationletter',
  LIQUIDATION_AND_BANKRUPTCY: 'liquidationandbankruptcy',
  MEMORANDUM: 'memorandum',
  NATIONAL_ID_CARD: 'nationalidcard',
  OPINION_FROM_US_COUNSEL: 'opinionfromuscounsel',
  OTHER_GOV_ID: 'othergovid',
  OWNER_REPORTING_STATEMENT: 'ownerreportingstatement',
  PARTNERSHIP: 'partnership',
  PASSPORT: 'passport',
  PERMIT_OF_RESIDENCE: 'permitofresidence',
  POWER_OF_ATTORNEY: 'powerofattorney',
  QDD_DOCUMENTATION: 'qdddocumentation',
  QSL_STATEMENT: 'qslstatement',
  WRITTEN_EXPLANATION: 'writtenexplanation',
  REG_CERT: 'regcert',
  TAXPAYER_CERT: 'taxpayercert',
  TIN_NOT_ISSUED: 'tinnotissued',
  TRUST_AGREEMENT: 'trustagreement',
  TRUST_DEED: 'trustdeed',
  TRUSTEE_DOCUMENTED_TRUST_LETTER: 'trusteedocumentedtrustletter',
  VOTER_CARD: 'votercard',
  WILL: 'will',
  NOT_LISTED: 'notlisted',
  // Withholding Statements
  ALT_WHD_STATEMENT: 'altwhdstatement',
  DETAILED_WHD_STATEMENT: 'detailedwhdstatement',
  POOLED_WHD_STATEMENT: 'pooledwhdstatement',
  SIMPLE_WHD_STATEMENT: 'simplewhdstatement'
};

const documentTypes = [
  { key: DocumentKeys.AFFIDAVIT, value: 'Affidavit Stating Not Private Foundation' },
  { key: DocumentKeys.ARMED_FORCES_ID, value: 'Armed Forces ID Card' },
  { key: DocumentKeys.ARTICLE_ASSOC, value: 'Articles of Association' },
  { key: DocumentKeys.ARTICLE_INCORP, value: 'Articles of Incorporation' },
  { key: DocumentKeys.AUDITORS_LETTER, value: 'Auditor\'s Letter' },
  { key: DocumentKeys.BANK_ID_CARD, value: 'Bank Card' },
  { key: DocumentKeys.CEDULA, value: 'Identification Documents' },
  { key: DocumentKeys.CERT_INCORP, value: 'Certificate of Incorporation' },
  { key: DocumentKeys.CERT_LTD_PARTNER, value: 'Certificate of Limited Partnership' },
  { key: DocumentKeys.CERT_LOSS_NATIONALITY, value: 'Certificate of Loss of Nationality' },
  { key: DocumentKeys.CERT_PARTNERSHIP, value: 'Certificate of Partnership' },
  { key: DocumentKeys.CERT_REG, value: 'Certificate of Registration' },
  { key: DocumentKeys.CERT_OF_RESIDENCE, value: 'Certificate of Residence' },
  { key: DocumentKeys.CONTROLLING_PERSON_SELF_CERTIFICATION, value: 'Controlling Person Self-Certification' },
  { key: DocumentKeys.DATE_OF_BIRTH_SUPPORTING_DOC, value: 'Date of Birth Supporting Doc' },
  { key: DocumentKeys.DRIVING_LICENCE, value: 'Driver’s License' },
  { key: DocumentKeys.FORM_8233, value: 'Form 8233' },
  { key: DocumentKeys.FORM_8832, value: 'Form 8832' },
  { key: DocumentKeys.IRS_DETERMINATION_LETTER, value: 'IRS Determination Letter' },
  { key: DocumentKeys.LIQUIDATION_AND_BANKRUPTCY, value: 'Liquidation and Bankruptcy' },
  { key: DocumentKeys.MEMORANDUM, value: 'Memorandum of Association' },
  { key: DocumentKeys.NATIONAL_ID_CARD, value: 'National ID Card' },
  { key: DocumentKeys.OPINION_FROM_US_COUNSEL, value: 'Opinion From U.S. Counsel' },
  { key: DocumentKeys.OTHER_GOV_ID, value: 'Other Government ID' },
  { key: DocumentKeys.OWNER_REPORTING_STATEMENT, value: 'Owner Reporting Statement' },
  { key: DocumentKeys.PARTNERSHIP, value: 'Partnership Agreement' },
  { key: DocumentKeys.PASSPORT, value: 'Passport' },
  { key: DocumentKeys.PERMIT_OF_RESIDENCE, value: 'Permit of Residence' },
  { key: DocumentKeys.POWER_OF_ATTORNEY, value: 'Power Of Attorney' },
  { key: DocumentKeys.QDD_DOCUMENTATION, value: 'QDD Documentation' },
  { key: DocumentKeys.QSL_STATEMENT, value: 'QSL Statement' },
  { key: DocumentKeys.WRITTEN_EXPLANATION, value: 'Reasonable Written Explanation' },
  { key: DocumentKeys.REG_CERT, value: 'Registration Certificate' },
  { key: DocumentKeys.TAXPAYER_CERT, value: 'Taxpayer Certificate' },
  { key: DocumentKeys.TIN_NOT_ISSUED, value: 'Tin Not Issued' },
  { key: DocumentKeys.TRUST_AGREEMENT, value: 'Trust Agreement' },
  { key: DocumentKeys.TRUST_DEED, value: 'Trust Deed' },
  { key: DocumentKeys.TRUSTEE_DOCUMENTED_TRUST_LETTER, value: 'Trustee Documented Trust Letter' },
  { key: DocumentKeys.VOTER_CARD, value: 'Voter Registration Card' },
  { key: DocumentKeys.WILL, value: 'Will' },
  { key: DocumentKeys.NOT_LISTED, value: 'Other document type not listed above' },
  // Withholding Statements
  { key: DocumentKeys.ALT_WHD_STATEMENT, value: 'Alt Withholding Statement' },
  { key: DocumentKeys.DETAILED_WHD_STATEMENT, value: 'Detailed Withholding Statement' },
  { key: DocumentKeys.POOLED_WHD_STATEMENT, value: 'Pooled Withholding Statement' },
  { key: DocumentKeys.SIMPLE_WHD_STATEMENT, value: 'Simple Withholding Statement' },
];

export default documentTypes;

export const getKey = (supportingDoc) => {
  const doc = documentTypes.find(d => d.key === supportingDoc);
  return doc ? doc.key : null;
};
